import { z } from 'zod';
import { BranchCodeSchema } from './requests.js';

export const TransferItemSchema = z.object({
  sku: z.string().min(1),
  qty: z.number().int().positive(),
});
export type TransferItemInput = z.infer<typeof TransferItemSchema>;

export const CreateTransferOrderSchema = z.object({
  from_branch: BranchCodeSchema.default('bp'),
  to_branch: BranchCodeSchema,
  items: z.array(TransferItemSchema).min(1),
  note: z.string().max(1000).optional(),
  // approve immediately (super_admin creates = already approved)
  mark_approved: z.boolean().optional().default(true),
}).refine((d) => d.from_branch !== d.to_branch, {
  message: 'from_branch and to_branch must differ',
  path: ['to_branch'],
});
export type CreateTransferOrderInput = z.infer<typeof CreateTransferOrderSchema>;
